import { render, staticRenderFns } from "./LessonLayout.vue?vue&type=template&id=2c495f06&"
import script from "./LessonLayout.vue?vue&type=script&lang=js&"
export * from "./LessonLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../aristotle-website/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports